import { render } from "./BangbotEntry.vue?vue&type=template&id=69139d0c&scoped=true"
import script from "./BangbotEntry.vue?vue&type=script&lang=js"
export * from "./BangbotEntry.vue?vue&type=script&lang=js"

import "./BangbotEntry.vue?vue&type=style&index=0&id=69139d0c&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/DLJY-Web-Test/example/main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69139d0c"]])

export default __exports__